(() => {
  const initialize = (root = document) => {
    const sections = root.matches?.('.g-proof--reviews')
      ? [root]
      : root.querySelectorAll?.('.g-proof--reviews') || [];

    sections.forEach((section) => {
      const track = section.querySelector('[data-proof-track]');
      if (!track || track.dataset.reviewReady) return;
      track.dataset.reviewReady = 'true';

      const originalCards = Array.from(track.children);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let loopStart = null;

      if (!window.Shopify?.designMode && !reducedMotion && originalCards.length > 1) {
        originalCards.forEach((card) => {
          const duplicate = card.cloneNode(true);
          duplicate.setAttribute('aria-hidden', 'true');
          duplicate.inert = true;
          duplicate.removeAttribute('data-shopify-editor-block');
          duplicate.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          track.appendChild(duplicate);
        });
        loopStart = track.children[originalCards.length];
      }

      let dragging = false;
      let pointerActive = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      let pauseUntil = 0;
      let frame = null;
      let lastTime = 0;

      const pauseBriefly = () => {
        pauseUntil = performance.now() + 1600;
      };

      section.querySelector('[data-review-prev]')?.addEventListener('click', () => {
        pauseBriefly();
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
      section.querySelector('[data-review-next]')?.addEventListener('click', () => {
        pauseBriefly();
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });

      track.addEventListener('pointerdown', (event) => {
        pointerActive = true;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 4) moved = true;
        track.scrollLeft = startScroll - distance;
      });
      const finishPointer = () => {
        dragging = false;
        pointerActive = false;
        pauseBriefly();
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', finishPointer);
      track.addEventListener('pointercancel', finishPointer);
      track.addEventListener('wheel', pauseBriefly, { passive: true });
      track.addEventListener('click', (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);

      if (!loopStart) return;

      const animate = (time) => {
        if (lastTime && !document.hidden && !dragging && !pointerActive && time > pauseUntil && !track.contains(document.activeElement)) {
          track.scrollLeft += (time - lastTime) * 0.03;
          const loopWidth = loopStart.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          if (loopWidth > 0 && track.scrollLeft >= loopWidth) track.scrollLeft -= loopWidth;
        }
        lastTime = time;
        frame = requestAnimationFrame(animate);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && frame === null) frame = requestAnimationFrame(animate);
          if (!entry.isIntersecting && frame !== null) {
            cancelAnimationFrame(frame);
            frame = null;
            lastTime = 0;
          }
        });
        observer.observe(section);
      } else {
        frame = requestAnimationFrame(animate);
      }
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
